'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _domLib = require('dom-lib');

var _Transition = require('./Transition');

var _Transition2 = _interopRequireDefault(_Transition);

var _createChainedFunction = require('../utils/createChainedFunction');

var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var capitalize = function capitalize(str) {
  return str[0].toUpperCase() + str.substr(1);
};
var triggerBrowserReflow = function triggerBrowserReflow(node) {
  return node.offsetHeight;
};

var MARGINS = {
  height: ['marginTop', 'marginBottom'],
  width: ['marginLeft', 'marginRight']
};

function getDimensionValue(dimension, elem) {
  var value = elem['offset' + capitalize(dimension)];
  var margins = MARGINS[dimension];

  return value + parseInt((0, _domLib.getStyle)(elem, margins[0]), 10) + parseInt((0, _domLib.getStyle)(elem, margins[1]), 10);
}

function getScrollDimensionValue(elem, dimension) {
  var value = elem['scroll' + capitalize(dimension)];
  return value + 'px';
}

var Collapse = function (_React$Component) {
  _inherits(Collapse, _React$Component);

  function Collapse(props, context) {
    _classCallCheck(this, Collapse);

    var _this = _possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props, context));

    _this.onEnterListener = _this.handleEnter.bind(_this);
    _this.onEnteringListener = _this.handleEntering.bind(_this);
    _this.onEnteredListener = _this.handleEntered.bind(_this);
    _this.onExitListener = _this.handleExit.bind(_this);
    _this.onExitingListener = _this.handleExiting.bind(_this);
    return _this;
  }

  // for testing


  _createClass(Collapse, [{
    key: 'getTransitionInstance',
    value: function getTransitionInstance() {
      return this.transition;
    }
  }, {
    key: 'handleEnter',
    value: function handleEnter(elem) {
      var dimension = this.dimension();
      elem.style[dimension] = '0';
    }
  }, {
    key: 'handleEntering',
    value: function handleEntering(elem) {
      var dimension = this.dimension();

      elem.style[dimension] = getScrollDimensionValue(elem, dimension);
    }
  }, {
    key: 'handleEntered',
    value: function handleEntered(elem) {
      var dimension = this.dimension();
      elem.style[dimension] = null;
    }

    /* -- Collapsing -- */

  }, {
    key: 'handleExit',
    value: function handleExit(elem) {
      var dimension = this.dimension();
      var value = this.props.getDimensionValue(dimension, elem);
      elem.style[dimension] = value + 'px';
    }
  }, {
    key: 'handleExiting',
    value: function handleExiting(elem) {
      var dimension = this.dimension();

      triggerBrowserReflow(elem);
      elem.style[dimension] = '0';
    }
  }, {
    key: 'dimension',
    value: function dimension() {
      return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          dimension = _props.dimension,
          getDimensionValue = _props.getDimensionValue,
          role = _props.role,
          className = _props.className,
          onExited = _props.onExited,
          onEnter = _props.onEnter,
          onEntering = _props.onEntering,
          onEntered = _props.onEntered,
          onExit = _props.onExit,
          onExiting = _props.onExiting,
          props = _objectWithoutProperties(_props, ['dimension', 'getDimensionValue', 'role', 'className', 'onExited', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting']);

      var enter = (0, _createChainedFunction2.default)(this.onEnterListener, onEnter);
      var entering = (0, _createChainedFunction2.default)(this.onEnteringListener, onEntering);
      var entered = (0, _createChainedFunction2.default)(this.onEnteredListener, onEntered);
      var exit = (0, _createChainedFunction2.default)(this.onExitListener, onExit);
      var exiting = (0, _createChainedFunction2.default)(this.onExitingListener, onExiting);

      return _react2.default.createElement(_Transition2.default, _extends({}, props, {
        ref: function ref(_ref) {
          _this2.transition = _ref;
        },
        'aria-expanded': role ? this.props.in : null,
        className: (0, _classnames2.default)(className, { width: this.dimension() === 'width' }),
        exitedClassName: 'collapse',
        exitingClassName: 'collapsing',
        enteredClassName: 'collapse in',
        enteringClassName: 'collapsing',
        onEnter: enter,
        onEntering: entering,
        onEntered: entered,
        onExit: exit,
        onExiting: exiting,
        onExited: onExited
      }));
    }
  }]);

  return Collapse;
}(_react2.default.Component);

Collapse.displayName = 'Collapse';
Collapse.propTypes = {
  in: _propTypes2.default.bool,
  unmountOnExit: _propTypes2.default.bool,
  transitionAppear: _propTypes2.default.bool,
  timeout: _propTypes2.default.number,
  onEnter: _propTypes2.default.func,
  onEntering: _propTypes2.default.func,
  onEntered: _propTypes2.default.func,
  onExit: _propTypes2.default.func,
  onExiting: _propTypes2.default.func,
  onExited: _propTypes2.default.func,
  dimension: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['height', 'width']), _propTypes2.default.func]),
  getDimensionValue: _propTypes2.default.func,
  role: _propTypes2.default.string
};
Collapse.defaultProps = {
  in: false,
  timeout: 300,
  unmountOnExit: false,
  transitionAppear: false,
  dimension: 'height',
  getDimensionValue: getDimensionValue
};
exports.default = Collapse;